import React from 'react';
import { AppBar, Toolbar, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import '../App.css';

const MenuBar = () => {
  return (
    <AppBar position="static" style={{ backgroundColor: '#121212' }}>
      <Toolbar style={{ justifyContent: 'space-around' }}>
        <Button color="inherit" component={Link} to="/olivia-rodrigo">
          <Typography variant="button" style={{ fontFamily: 'Arial, sans-serif' }}>
            Olivia Rodrigo
          </Typography>
        </Button>
        <Button color="inherit" component={Link} to="/travis-scott">
          <Typography variant="button" style={{ fontFamily: 'Arial, sans-serif' }}>
            Travis Scott
          </Typography>
        </Button>
        <Button color="inherit" component={Link} to="/stray-kids">
          <Typography variant="button" style={{ fontFamily: 'Arial, sans-serif' }}>
            Stray Kids
          </Typography>
        </Button>
        <Button color="inherit" component={Link} to="/coldplay">
          <Typography variant="button" style={{ fontFamily: 'Arial, sans-serif' }}>
            Coldplay
          </Typography>
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default MenuBar;
